import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IReviewData } from '../../review-management.interfaces';
import { ReviewsService } from '../../reviews.service';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

interface DeleteDialogData extends IReviewData {
  actionType: 'Response' | 'Review';
}

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss'],
})
export class DeletePopupComponent implements OnInit {
  publishObject: DeleteDialogData;

  constructor(
    public ref: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private reviewsService: ReviewsService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.publishObject = this.dynamicDialogConfig?.data as DeleteDialogData;
  }

  /**
   * Deletes either a response or a full review and closes the dialog with the result.
   * For response deletion, this method reads `loginId`/`accountId` from dialog config data first and falls back to review fields.
   * @returns None.
   */
  deleteItem(): void {
    if (!this.publishObject) {
      this.ref.close(false);
      return;
    }
    const dialogData = this.dynamicDialogConfig?.data ?? {};
    const effectiveLoginId = Number(dialogData.loginId ?? this.publishObject.loginId);
    const effectiveAccountId = Number(dialogData.accountId ?? dialogData.account_id ?? this.publishObject.account_id);

    if (this.publishObject.actionType === 'Response') {
      this.reviewsService
        .deleteReviewResponseNewEndpoint(
          this.publishObject.reviewId,
          effectiveLoginId,
          effectiveAccountId,
          'google/reviews/response'
        )
        .subscribe({
          next: (res) =>{
            this.ref.close(res);
            this.dialogService.open(SuccessPopupComponent, {
              data: { ...this.dynamicDialogConfig?.data,customContent: 'Review response deleted successfully', },
              closable: false,
              width: '800px',
              height: '300px',
            })
          },
          error: () => this.ref.close(false),
        });
      return;
    }

    this.reviewsService.deleteReviewNewEndpoint( 
      this.publishObject.reviewId,
      effectiveLoginId,
      effectiveAccountId,
      'reviews')
      .subscribe({
      next: (res) =>{
        this.ref.close(res);
        this.dialogService.open(SuccessPopupComponent, {
          data: { ...this.dynamicDialogConfig?.data,customContent: 'Review deleted successfully', },
          closable: false,
          width: '800px',
          height: '300px',
        })
      },
      error: () => this.ref.close(false),
    });
  }

  /**
   * Closes the delete confirmation dialog without performing any action.
   * This is a no-op cancel path and returns no payload.
   * @returns None.
   */
  closeDialog(): void {
    this.ref.close();
  }
}
